import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-drop",
  "use": "icon-arrow-drop-usage",
  "viewBox": "0 0 12.672 23.132",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12.672 23.132\" id=\"icon-arrow-drop\">\r\n  <path id=\"icon-arrow-drop_icon\" d=\"M308.151,123.491l-9.586-9.586a1.16,1.16,0,0,1,1.64-1.64l10.353,10.353a1.3,1.3,0,0,1,0,1.747l-10.35,10.353a1.16,1.16,0,0,1-1.64-1.64l2.422-2.423Z\" transform=\"translate(-298.225 -111.925)\" fill=\"#6e6e6e\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol